import doneIcon from '@iconify/icons-material-symbols/done';
import errorIcon from '@iconify/icons-material-symbols/error-outline';
import infoIcon from '@iconify/icons-material-symbols/info-outline';
import warningIcon from '@iconify/icons-material-symbols/warning-outline';
import type { ReactNode } from 'react';
import type { VariantProps } from '#pie/utils/TailwindUtils';
import { tv } from '#pie/utils/TailwindUtils';
import { Icon, type IconProps } from '../icon/Icon';

export interface MessageProps extends VariantProps<typeof message> {
  icon?: IconProps['icon'];
  children?: ReactNode;
  className?: string;
}

const defaultIcons = {
  error: errorIcon,
  info: infoIcon,
  success: doneIcon,
  warning: warningIcon,
  default: infoIcon,
} as const;

export function Message({
  icon,
  children,
  variant = 'default',
  className,
}: MessageProps) {
  const s = message({ variant });

  const iconToUse = icon ?? defaultIcons[variant];

  return (
    <div className={s.base({ className })}>
      <Icon icon={iconToUse} size={20} className={s.icon()} />
      <div>{children}</div>
    </div>
  );
}

const message = tv({
  base: 'flex bg-transparent p-3 rounded-md text-content-primary gap-2 items-center',
  slots: {
    icon: 'flex-shrink-0',
  },
  variants: {
    variant: {
      error: {
        base: 'bg-surface-error',
        icon: 'text-content-error',
      },
      info: {
        base: 'bg-surface-info',
        icon: 'text-content-info',
      },
      success: {
        base: 'bg-surface-success',
        icon: 'text-content-success',
      },
      warning: {
        base: 'bg-surface-warning',
        icon: 'text-content-warning',
      },
      default: {
        base: 'bg-surface-subtle-gray',
        icon: 'text-content-body',
      },
    },
  },
});
